import type { FilterValuesType } from 'elements/hardwareFilter/type'
import { assign } from 'lodash'
import { useMemo } from 'react'
import {
  FILTER_NODE_KEY_AND_FACTORY,
  HARDWARE_FILTERS_DESIGN_PAGE_CONFIG_V2,
} from '../elements/hardwareFilter/constantsV2'

export const useDynamicFilterValues = (): FilterValuesType => {
  return useMemo(() => {
    // Create filter nodes from configuration
    const createFilterNodes = () => {
      return HARDWARE_FILTERS_DESIGN_PAGE_CONFIG_V2.map((config) => {
        const factory = FILTER_NODE_KEY_AND_FACTORY[config.key]
        return factory ? factory(config) : null
      }).filter(Boolean)
    }

    // Get dynamic filter values from all filter nodes
    const getDynamicFilterValues = (filterNodes: any[]): FilterValuesType => {
      const dynamicFilterValues: FilterValuesType = {}

      filterNodes.forEach((node) => {
        if (!node?.getMatchedValueFromSpecsData) {
          return
        }

        try {
          const defaultValue = node.getMatchedValueFromSpecsData()

          if (defaultValue) {
            assign(dynamicFilterValues, defaultValue)
          }
        } catch (error) {
          console.warn('Error getting default value for filter node:', node.key, error)
        }
      })

      return dynamicFilterValues
    }

    // Execute the logic
    const filterNodes = createFilterNodes()
    return getDynamicFilterValues(filterNodes)
  }, [])
}
